import { Component, OnInit, Output, EventEmitter, Input, AfterContentInit } from '@angular/core';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';

import { formatDate, getNextDate, getPreviousDate, formatDateGeneral } from '../Utilities/date-utilities';
import { SEARCH_CURRENCY_CODE } from '../../app-constants';

import { CommonService } from '../services/common.service';
import { HomeService } from '../../booking/booking-services/home.service';
import { Passenger } from '../../models/search';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
import { SharedDatePickerHeader } from '../Utilities/shared-picker-custom-header';
const moment = _moment;


// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


declare var $: any;

@Component({
  selector: 'app-search-dynamic',
  templateUrl: './search-dynamic.component.html',
  styleUrls: ['./search.dynamic.component.css', './search-dynamic.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.

    {
      provide: MAT_DATE_LOCALE, useValue: 'nl-NL'
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class SearchDynamicComponent implements OnInit, AfterContentInit {

  @Input() isOneWayRouteSelected: boolean;
  @Output() isEditSearch = new EventEmitter<any>();
  deptDatePickerOptions: IMyDpOptions;
  retDatePickerOptions: IMyDpOptions;
  multiCitydeptDatePickerOptions: IMyDpOptions;
  departureDate: Date = new Date();
  arrivalDate: Date = new Date();
  locErrorMap = new Map();
  flightSearchDates: any = {};

  @Input() searchObj: any = {};
  @Input() tripType: string;
  @Input() fromLocationObj: any;
  @Input() toLocationObj: any;

  originName: any;
  destinationName: any;
  multiCityOrigin: any = {};
  multiCityDestination: any = {};

  multiDeptDate: Date = new Date();
  origin: any;
  destination: any;
  passengers: Passenger = { Adult: 1, Child: 0, Infant: 0 };
  dateType: any = '';
  header = SharedDatePickerHeader;
  minDate = new Date();

  chkshowDirectFlightOnly = true;
  showDirectFlightOnly = '';
  flightNewCount: number;
  displayNone: any ="none";
  searchText: string = "Toon Zoeken";

  constructor(private _router: Router, public _commonService: CommonService, private _homeService: HomeService) {
    // console.log(this.searchObj)
    this.checkShowDirectFlightOnly();
  }

  checkShowDirectFlightOnly() {
    const showDirectFlightOnlyKey = localStorage.getItem('showDirectFlightOnly');
    if (showDirectFlightOnlyKey === null || showDirectFlightOnlyKey === '') {
      localStorage.setItem('showDirectFlightOnly', 'true');
      this.chkshowDirectFlightOnly = true;
    }
    if (showDirectFlightOnlyKey === 'true') {
      this.chkshowDirectFlightOnly = true;
    }
    if (showDirectFlightOnlyKey === 'false') {
      this.chkshowDirectFlightOnly = false;
    }
  }

  ngOnInit() {

  }

  showTravellerPopup() {
    $('#travellerModal').modal('show');
  }
  hideTravellerForm() {
    $('#travellerModal').modal('hide');

  }
  hideFrom(action)
  {
    if(action == "none")
    {
      this.displayNone = "block";
      this.searchText = "Zoekopdracht verbergen";
    }
    else
    {
      this.displayNone = "none";
      this.searchText = "Toon Zoeken";


    }
  }

  ngAfterContentInit() {
    this.deptDatePickerOptions = Object.assign({}, this._commonService.searchDatePickerOptions);
    this.retDatePickerOptions = Object.assign({}, this._commonService.searchDatePickerOptions);
    this.multiCitydeptDatePickerOptions = Object.assign({}, this._commonService.searchDatePickerOptions);

    this.searchObj = JSON.parse(sessionStorage.getItem('SearchObj'));
    this.tripType = sessionStorage.getItem('TripType');
    this.fromLocationObj = JSON.parse(localStorage.getItem('origin'));
    this.originName = this.fromLocationObj.Name.split(',')[0];
    this.toLocationObj = JSON.parse(localStorage.getItem('destination'));
    this.destinationName = this.toLocationObj.Name.split(',')[0];
    this.passengers = this.searchObj != null ? this.searchObj.PoolRequest.Passengers : {
      'Adult': 1,
      'Child': 0,
      'Infant': 0
    };
    this.setDatePickerDefaults();
    this.flightSearchDates.isDateValid = true;
  }

  onFlightDateSelect(dateType) {
    this.flightSearchDates.isDateValid = true;
    if (dateType === 'DEPARTURE') {
      this.flightSearchDates.isDeptDateEmpty = false;
      this.flightSearchDates.departure = this.departureDate;
      this.flightSearchDates.fromDate = formatDateGeneral(this.departureDate);
      // console.log(this.flightSearchDates.fromDate);
      var selctedDate: any = this.departureDate;
      this.arrivalDate.setDate(selctedDate._d.getDate() + 1);
      // console.log(selctedDate);
      // console.log(this.flight_returnDate)
    } else {
      this.flightSearchDates.return = this.arrivalDate;
      this.flightSearchDates.toDate = formatDateGeneral(this.arrivalDate);
    }

    if (this.tripType === 'R') {
      this.flightSearchDates.isDateValid = (!this.flightSearchDates.departure || !this.flightSearchDates.return) ? true :
        (this.flightSearchDates.departure <= this.flightSearchDates.return ? true : false);
    }

    if (this.tripType === 'M') {

    }
  }

  onFlightMultiDeptDateChange() {
    this.flightSearchDates.isMultiDeptDateEmpty = !this.multiDeptDate ? true : false;
    this.flightSearchDates.multiDeparture = this.multiDeptDate;
    this.flightSearchDates.multiFromDate = formatDateGeneral(this.multiDeptDate);
  }


  onMultiLocationSelect(result, locationType) {
    if (locationType === 'FROM') {
      this.multiCityOrigin = result ? result : {};
      localStorage.setItem('multiCityOrigin', JSON.stringify(result));
      this.locErrorMap['MULTI_FROM'] = false;
    } else {
      this.multiCityDestination = result ? result : {};
      localStorage.setItem('multiCityDestination', JSON.stringify(result));
      this.locErrorMap['MULTI_TO'] = false;
    }
  }

  onTripTypeChange(event) {
    this.tripType = event.target.value;
  }

  /**
   * setting the location from the search bar
   */
  onLocationSelect(result, locationType) {
    if (locationType === 'FROM') {
      this.fromLocationObj = result;
      localStorage.setItem('origin', JSON.stringify(result));
      this.locErrorMap['FROM'] = false;
    } else {
      this.toLocationObj = result;
      localStorage.setItem('destination', JSON.stringify(result));
      this.locErrorMap['TO'] = false;
    }
  }

  onMultiDeptDateChange(event) {
    this.flightSearchDates.isMultiDeptDateEmpty = !event.jsdate ? true : false;
    this.flightSearchDates.multiDeparture = new Date(event.jsdate);
    this.flightSearchDates.multiFromDate = formatDate(event);
  }

  /**
   * function is used to increase the person count in the dropdown
   */
  incrementCount(personType) {
    if (personType === 'adult') {
      this.passengers.Adult = this.passengers.Adult + 1;
    } else if (personType === 'child') {
      this.passengers.Child = this.passengers.Child + 1;
    } else { this.passengers.Infant = this.passengers.Infant + 1; }
  }

  /**
  * function is used to decrease the person count in the dropdown
  */
  decrementCount(personType) {
    if (personType === 'adult') {
      this.passengers.Adult = this.passengers.Adult - 1;
    } else if (personType === 'child') {
      this.passengers.Child = this.passengers.Child - 1;
    } else { this.passengers.Infant = this.passengers.Infant - 1; }
  }


  /**
   * function called by the search button to get the search results
   */
  validateSearch() {
    sessionStorage.removeItem("SearchObjDus");
    sessionStorage.removeItem("SearchObjBru");
    sessionStorage.removeItem("SearchObjRot");
    sessionStorage.removeItem("SearchObjEin");
    sessionStorage.removeItem("SearchObjAms");
    sessionStorage.removeItem("firstAlternativeSearchClicked");

    this.locErrorMap['FROM'] = !this.fromLocationObj.Code ? true : false;
    this.locErrorMap['TO'] = !this.toLocationObj.Code ? true : false;
    if (this.tripType === 'O' && !this.flightSearchDates.isDateValid) {
      this.flightSearchDates.isDateValid = !this.flightSearchDates.isDateValid;
    }
    const isSearchValid = (this.locErrorMap['FROM'] || this.locErrorMap['TO'] || !this.flightSearchDates.isDateValid) ? false : true;
    if (isSearchValid) { this.setSearchObj(); }

    sessionStorage.setItem("firstSearchFromHomeIsSuccessOrNot", "started");
    localStorage.removeItem("currentAlternateAiport");
    localStorage.removeItem("currentReturnAlternateAiport");
  }

  setSearchObj() {
    const requestObj = {
      'PoolRequest': {
        'Routes': this.getRoutes(),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };

    const requestObjDus = {
      'PoolRequest': {
        'Routes': this.getRoutesExtra('DUS'),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };
    const requestObjBru = {
      'PoolRequest': {
        'Routes': this.getRoutesExtra('BRU'),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };
    const requestObjRot = {
      'PoolRequest': {
        'Routes': this.getRoutesExtra('ROT'),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };
    const requestObjEin = {
      'PoolRequest': {
        'Routes': this.getRoutesExtra('EIN'),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };
    const requestObjAms = {
      'PoolRequest': {
        'Routes': this.getRoutesExtra('AMS'),
        'Passengers': this.passengers,
        'Preference': { 'RequiredCarrierCodes': null, 'CabinType': null }
      },
      'CurrencyCode': SEARCH_CURRENCY_CODE
    };


    sessionStorage.setItem('SearchObjDus', JSON.stringify(requestObjDus));
    sessionStorage.setItem('SearchObjBru', JSON.stringify(requestObjBru));
    sessionStorage.setItem('SearchObjRot', JSON.stringify(requestObjRot));
    sessionStorage.setItem('SearchObjEin', JSON.stringify(requestObjEin));
    sessionStorage.setItem('SearchObjAms', JSON.stringify(requestObjAms));

    sessionStorage.setItem("OriginCode", this.fromLocationObj.Code);
    sessionStorage.setItem('TripType', this.tripType);
    sessionStorage.setItem('SearchObj', JSON.stringify(requestObj));
    if (this.tripType === 'R') {
      const newReqObj = Object.assign({}, requestObj);
      !this.isOneWayRouteSelected ? newReqObj.PoolRequest.Routes.pop() : newReqObj.PoolRequest.Routes.shift();
      this.searchFlights(newReqObj);
    } else { this.searchFlights(requestObj); }
    this.addShowDirectFlightOnly();
  }

  addShowDirectFlightOnly() {
    if (!this.chkshowDirectFlightOnly) {
      localStorage.setItem('showDirectFlightOnly', 'false');
    } else {
      localStorage.setItem('showDirectFlightOnly', 'true');
    }
  }

  getFlightCount(result) {
    this.flightNewCount = 0;
    var directCount = 0;
    var stopCount = 0;
    if (result != undefined) {
      for (const fgroup of result) {
        for (const item of fgroup.Routes[0]) {
          var segmentCount = item.Segments.length;
          if (segmentCount == 1 && !item.Alternative) {
            directCount++;
          }
          else if (segmentCount > 1 && !item.Alternative) {
            stopCount++;
          }
        }
      }
    }
    if (localStorage.getItem("showDirectFlightOnly") == 'true') {
      this.flightNewCount = directCount;
    }
    else {
      this.flightNewCount = stopCount;
    }
  }


  /**
   * function calls search flight api
   */
  searchFlights(searchObj) {
    // localStorage.setItem('SearchObj', JSON.stringify(searchObj));
    this._homeService.searchFlights(searchObj).subscribe((response: any) => {
      if (response.status && response.message === 'success' && response.data.Reader.TotalGroupCount > 0) {

        this._homeService.setSearchResults(response.data);

        this.getFlightCount(response.data.Reader.FareGroups);
        if (this.flightNewCount == 0) {
       
          if (sessionStorage.getItem("firstSearchFromHomeIsSuccessOrNot") == "started") {
            sessionStorage.setItem("firstSearchFromHomeIsSuccessOrNot", "NotSuccess")
          }
          this.triggerNoResultsModal();
        }
        else {

          this.isEditSearch.emit({
            'isEdit': true, 'searchdate': searchObj.PoolRequest.Routes[0].Departure.Date,
            'originName': JSON.parse(localStorage.getItem('origin')).Name.split(',')[0],
            'destinationName': JSON.parse(localStorage.getItem('destination')).Name.split(',')[0],
            'dayType': this.dateType, 'travellers': searchObj.PoolRequest.Passengers
          });
          this.dateType = '';
          this.navigateToLandingPage();
          sessionStorage.setItem('searchResults', JSON.stringify(response.data));
          sessionStorage.removeItem('parkingDetails');
        }
      }
      else { this.triggerNoResultsModal(); }


    });
  }

  navigateToLandingPage() {
    this._router.navigate(['/vliegtickets/booking']);
  }

  triggerNoResultsModal() {
    document.getElementById('no-results-modal-btn').click();
  }

  getRoutes() {
    const routes = [];
    const fromRoute = Object.assign({}, this.getRouteObj());
    fromRoute.Origin.Code = this.fromLocationObj.Code;
    fromRoute.Origin.IsCity = this.fromLocationObj.Type === 1 ? true : false;
    fromRoute.Destination.Code = this.toLocationObj.Code;
    fromRoute.Destination.IsCity = this.toLocationObj.Type === 1 ? true : false;
    fromRoute.Departure = Object.assign({}, this.getDepartureObj('FROM'));
    fromRoute.FlightType.MaxConnections = 0;
    fromRoute.FlightType.ConnectionType = 4;
    routes.push(fromRoute);
    if (this.tripType === 'R') {
      const toRoute = Object.assign({}, this.getRouteObj());
      toRoute.Origin.Code = this.toLocationObj.Code;
      toRoute.Origin.IsCity = this.toLocationObj.Type === 1 ? true : false;
      toRoute.Destination.Code = this.fromLocationObj.Code;
      toRoute.Destination.IsCity = this.fromLocationObj.Type === 1 ? true : false;
      toRoute.Departure = Object.assign({}, this.getDepartureObj('TO'));
      toRoute.FlightType.MaxConnections = 1;
      toRoute.FlightType.ConnectionType = null;
      routes.push(toRoute);
    }
    else if (this.tripType === 'M') {
      const multiRoute = Object.assign({}, this.getRouteObj());
      multiRoute.Origin.Code = this.multiCityOrigin.Code;
      multiRoute.Origin.IsCity = this.multiCityOrigin.Type === 1 ? true : false;
      multiRoute.Destination.Code = this.multiCityDestination.Code;
      multiRoute.Destination.IsCity = this.multiCityDestination.Type === 1 ? true : false;
      multiRoute.Departure = Object.assign({}, this.getDepartureObj('MULTI'));
      multiRoute.FlightType.MaxConnections = 1;
      multiRoute.FlightType.ConnectionType = null;
      routes.push(multiRoute);
    }
    return routes;
  }

  getRoutesExtra(Dep) {
    const routes = [];
    const fromRoute = Object.assign({}, this.getRouteObj());
    fromRoute.Origin.Code = Dep;
    fromRoute.Origin.IsCity = this.fromLocationObj.Type === 1 ? true : false;
    fromRoute.Destination.Code = this.toLocationObj.Code;
    fromRoute.Destination.IsCity = this.toLocationObj.Type === 1 ? true : false;
    fromRoute.Departure = Object.assign({}, this.getDepartureObj('FROM'));
    fromRoute.FlightType.MaxConnections = 0;
    fromRoute.FlightType.ConnectionType = 4;
    routes.push(fromRoute);
    if (this.tripType === 'R') {
      const toRoute = Object.assign({}, this.getRouteObj());
      toRoute.Origin.Code = this.toLocationObj.Code;
      toRoute.Origin.IsCity = this.toLocationObj.Type === 1 ? true : false;
      toRoute.Destination.Code = Dep;
      toRoute.Destination.IsCity = this.fromLocationObj.Type === 1 ? true : false;
      toRoute.Departure = Object.assign({}, this.getDepartureObj('TO'));
      toRoute.FlightType.MaxConnections = 1;
      toRoute.FlightType.ConnectionType = null;
      routes.push(toRoute);
    } else if (this.tripType === 'M') {
      const multiRoute = Object.assign({}, this.getRouteObj());
      multiRoute.Origin.Code = Dep;
      multiRoute.Origin.IsCity = this.multiCityOrigin.Type === 1 ? true : false;
      multiRoute.Destination.Code = this.multiCityDestination.Code;
      multiRoute.Destination.IsCity = this.multiCityDestination.Type === 1 ? true : false;
      multiRoute.Departure = Object.assign({}, this.getDepartureObj('MULTI'));
      multiRoute.FlightType.MaxConnections = 1;
      multiRoute.FlightType.ConnectionType = null;
      routes.push(multiRoute);
    }
    return routes;
  }


  getRouteObj() {
    const routeObj = {
      'Origin': { 'Code': '', 'IsCity': false },
      'Destination': { 'Code': '', 'IsCity': false },
      'Departure': {},
      'FlightType': { 'MaxConnections': null, 'ConnectionType': null }
    };
    return routeObj;
  }

  getDepartureObj(type) {
    const departureObj: any = {};
    if (type === 'FROM') {
      departureObj.Date = this.flightSearchDates.fromDate;
      departureObj.DaysBefore = 1;
    } else {
      departureObj.Date = this.flightSearchDates.toDate;
      departureObj.DaysAfter = 1;
    }
    return departureObj;
  }

  setDatePickerDefaults() {
    const previousDate = new Date();
    previousDate.setDate(new Date().getDate() - 1);
    this.flightSearchDates.fromDate = formatDateGeneral(new Date())
    this.flightSearchDates.departure = new Date();
    this.departureDate = new Date();
    // this.departureDate = { date: { day: this.flightSearchDates.departure.getDate(),
    //                                month: this.flightSearchDates.departure.getMonth() + 1,
    //                                year: this.flightSearchDates.departure.getFullYear() }
    //                      };
    this.deptDatePickerOptions.disableUntil = {
      day: previousDate.getDate(), month: previousDate.getMonth() + 1,
      year: previousDate.getFullYear()
    };
    this.multiCitydeptDatePickerOptions.disableUntil = {
      day: previousDate.getDate(), month: previousDate.getMonth() + 1,
      year: previousDate.getFullYear()
    };
    if (this.tripType === 'R') {
      this.flightSearchDates.toDate = formatDateGeneral(new Date())
      this.flightSearchDates.return = new Date();
      this.arrivalDate = new Date();
      // this.arrivalDate = { date: { day: this.flightSearchDates.return.getDate(),
      //                              month: this.flightSearchDates.return.getMonth() + 1,
      //                              year: this.flightSearchDates.return.getFullYear() }
      //                    };
      this.retDatePickerOptions.disableUntil = {
        day: this.flightSearchDates.departure.getDate() - 1,
        month: this.flightSearchDates.departure.getMonth() + 1,
        year: this.flightSearchDates.departure.getFullYear()
      };
    }

    if (this.tripType === 'M') {
      this.flightSearchDates.multiFromDate = formatDateGeneral(new Date())
      this.flightSearchDates.multiDeparture = new Date()
      this.multiDeptDate = new Date();
      // this.multiDeptDate = { date: { day: this.flightSearchDates.multiDeparture.getDate(),
      //                              month: this.flightSearchDates.multiDeparture.getMonth() + 1,
      //                              year: this.flightSearchDates.multiDeparture.getFullYear() }
      //                    };
      this.retDatePickerOptions.disableUntil = {
        day: this.flightSearchDates.departure.getDate() - 1,
        month: this.flightSearchDates.departure.getMonth() + 1,
        year: this.flightSearchDates.departure.getFullYear()
      };
    }
  }

  onDateChange(event, dateType) {
    this.flightSearchDates.isDateValid = true;
    if (dateType === 'DEPARTURE') {
      this.flightSearchDates.departure = new Date(event.jsdate);
      this.flightSearchDates.fromDate = formatDate(event);
      let retDate = new Date(event.jsdate);
      retDate.setDate(retDate.getDate() + 1);
      // this.arrivalDate = { date: { day: retDate.getDate(), month: retDate.getMonth() + 1, year: retDate.getFullYear()} };
      this.retDatePickerOptions = Object.assign({}, this.deptDatePickerOptions);
      this.retDatePickerOptions.disableUntil = { day: event.date.day - 1, month: event.date.month, year: event.date.year };
      this.flightSearchDates.return = retDate;
      this.flightSearchDates.toDate = retDate.getFullYear() + '-' + JSON.stringify(retDate.getMonth() + 1) + '-' + retDate.getDate();
    } else {
      this.flightSearchDates.return = new Date(event.jsdate);
      this.flightSearchDates.toDate = formatDate(event);
    }
    if (this.tripType === 'R') {
      this.flightSearchDates.isDateValid = (!this.flightSearchDates.departure || !this.flightSearchDates.return) ? true :
        (this.flightSearchDates.departure <= this.flightSearchDates.return ? true : false);
      this.flightSearchDates.isReturnDateEmpty = (dateType === 'RETURN' && !event.jsdate) ? true : false;
    }

    if (this.tripType == 'M') {
      let retDate = new Date(event.jsdate);
      retDate.setDate(retDate.getDate() + 1);
      // this.multiDeptDate = { date: { day: retDate.getDate(), month: retDate.getMonth() + 1, year: retDate.getFullYear()} };        
      this.multiCitydeptDatePickerOptions = Object.assign({}, this.deptDatePickerOptions); // copying whole object inorder to reflect the disableUntil property change
      this.multiCitydeptDatePickerOptions.disableUntil = { day: event.date.day - 1, month: event.date.month, year: event.date.year };
    }
  }

  searchPreviousOrNextDay(dayType) {
    const searchObj = JSON.parse(sessionStorage.getItem('SearchObj'));
    this.dateType = dayType;
    if (!this.isOneWayRouteSelected) {
      const newFromDate = new Date(searchObj.PoolRequest.Routes[0].Departure.Date);
      searchObj.PoolRequest.Routes[0].Departure.Date = dayType === 'PREVIOUS' ? getPreviousDate(newFromDate) : getNextDate(newFromDate);
    } else {
      const newToDate = new Date(Date.parse(searchObj.PoolRequest.Routes[1].Departure.Date));
      searchObj.PoolRequest.Routes[1].Departure.Date = dayType === 'PREVIOUS' ? getPreviousDate(newToDate) : getNextDate(newToDate);
    }
    sessionStorage.setItem('SearchObj', JSON.stringify(searchObj));
    if (this.tripType === 'R') {
      const newReqObj = Object.assign({}, searchObj);
      !this.isOneWayRouteSelected ? newReqObj.PoolRequest.Routes.pop() : newReqObj.PoolRequest.Routes.shift();
      this.searchFlights(newReqObj);
    } else { this.searchFlights(searchObj); }
  }

  preventMenuClose(event) {
    event.stopPropagation();
  }

}
